<template>
    <div class="tw-info-box-container">
        <div class="tw-info-box-overlay" v-on:click="closeLinkedOccurrence()"></div>

        <div class="tw-info-box" v-on:click.stop>
            <div class="tw-info-box--header">
                <h3 class=""> {{linkedOccurrence.linked_item_title}}</h3>
            </div>
            
            <div v-if="linkedOccurrence.linked_item_photo" class="tw-info-box--image">
                <img v-bind:src="linkedOccurrence.linked_item_photo">
            </div>

            <div class="tw-info-box--content">
                <p class="tw-info"> {{linkedOccurrence.linked_item_description}} </p>
                <a class="tw-btn tw-btn--secondary tw-btn--md tw-btn--block" v-bind:href="url" target="_blank">
                    Open Page
                </a>
            </div>

            <div class="tw-text--left">
                <button type="button" class="tw-btn__link" v-on:click="closeLinkedOccurrence()">
                    Close
                </button>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component, Prop } from "vue-property-decorator";
    import TicketWidgetComponent from '../../TicketWidgetComponent';
    import LinkedOccurrenceModel from "../../../models/LinkedOccurrence";
    import moment from "moment-timezone";

    /** Location for the website */
    declare var WEBSITE_BASE: string;

    @Component({components: {}})

    export default class LinkedOccurrence extends TicketWidgetComponent {
        @Prop() public linkedOccurrence!: LinkedOccurrenceModel;

        url: string = '';

        mounted() {
            // if source is not partner then the link must direct to a designmynight page
            if(this.dmnOptions.source === 'partner' && this.linkedOccurrence.linked_item_external_link) {
                this.url = this.linkedOccurrence.linked_item_external_link;
            }
            else {
                this.url = WEBSITE_BASE + this.linkedOccurrence.linked_item_path;
            }
        }

        /**
         * @desc sets up the initial load of the calendar view
         */
        closeLinkedOccurrence() {
            this.$root.$emit('closeLinkedOccurrence');
        }
    }
</script>
